function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { forwardRef } from 'react';
import IconAddFilled from '~icons/carbon/add-filled';
import { theme } from '@arc/frontend/ui-theme';
const styles = {
  addButton: /*#__PURE__*/css({
    '&[data-disabled=true]': /*#__PURE__*/css({
      color: theme.colors.action.disabledBackground,
      cursor: 'default',
      svg: /*#__PURE__*/css({
        color: theme.colors.action.disabledBackground
      }, process.env.NODE_ENV === "production" ? "" : ";label:svg;"),
      'svg:active': {
        filter: 'none'
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:--data-disabled-true-;")
  }, process.env.NODE_ENV === "production" ? "" : ";label:addButton;"),
  icon: /*#__PURE__*/css({
    color: theme.colors.palettes.primary.main,
    width: 26,
    height: 26,
    '&:active': {
      filter: 'brightness(81%)'
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:icon;"),
  smallIcon: process.env.NODE_ENV === "production" ? {
    name: "1eg0rk6",
    styles: "width:18px;height:18px"
  } : {
    name: "n9l3y7-smallIcon",
    styles: "width:18px;height:18px;label:smallIcon;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};
export const buttonIconAddStyles = styles;
export const ButtonIconAdd = forwardRef(
// eslint-disable-next-line @typescript-eslint/no-shadow
function ButtonIconAdd({
  small = false,
  ...forwardedProps
}, ref) {
  return <button data-testid="button-icon-add" type="button" {...forwardedProps} ref={ref} css={styles.addButton}>
				<IconAddFilled css={[styles.icon, small && styles.smallIcon, "pointer-events:none;" + (process.env.NODE_ENV === "production" ? "" : ";label:ButtonIconAdd;")]} />
			</button>;
});